import React, { useCallback, useRef } from "react";
import { Table } from "antd";
import { useDrag, useDrop } from "react-dnd";
import update from "immutability-helper";
import "./DragSortingTable.scss";
const type = "DraggableBodyRow";

const DraggableBodyRow = ({
  index,
  moveRow,
  className,
  style,
  ...restProps
}) => {
  const ref = useRef();
  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: type,
    collect: (monitor) => {
      const { index: dragIndex } = monitor.getItem() || {};
      if (dragIndex === index) {
        return {};
      }
      return {
        isOver: monitor.isOver(),
        dropClassName:
          dragIndex < index ? " drop-over-downward" : " drop-over-upward",
      };
    },
    drop: (item) => {
      moveRow(item.index, index);
    },
  });
  const [, drag] = useDrag({
    type,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  drop(drag(ref));

  return (
    <tr
      ref={ref}
      className={`${className}${isOver ? dropClassName : ""}`}
      style={{ cursor: "move", ...style }}
      {...restProps}
    />
  );
};

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
];

const DragSortingTable = ({
  columnList,
  dataList,
  setDataList,
  updateFunction,
}) => {
  const components = {
    body: {
      row: DraggableBodyRow,
    },
  };

  const moveRow = useCallback((dragIndex, hoverIndex) => {
    if (dragIndex === hoverIndex) return;
  
    const dragRow = dataList[dragIndex];
    const hoverRow = dataList[hoverIndex];
    const isConsecutive = Math.abs(dragIndex - hoverIndex) === 1;
  
    const updatedList = update(dataList, {
      $splice: [
        [dragIndex, 1],
        [hoverIndex, 0, dragRow],
      ],
    }).map((item, index) => ({ ...item, order: index + 1 }));
  
    setDataList(updatedList);
  
    if (isConsecutive) {
      const newOrder = hoverRow.order;
      const newOrderHover = dragRow.order;
  
      updateFunction({ order: newOrder }, dragRow.id);
      updateFunction({ order: newOrderHover }, hoverRow.id);
    } else {
      updatedList.forEach(({ order, id }) => {
        updateFunction({ order }, id);
      });
    }
  }, [dataList, updateFunction]); 

  return (
    <Table
      columns={columnList}
      dataSource={dataList}
      components={components}
      onRow={(record, index) => ({
        index,
        moveRow,
      })}
      pagination={false}
      scroll={{ y: 300 }}
    />
  );
};

export default DragSortingTable;
